module.exports = "/_next/static/images/JosephDiMelis-316d105ef2806823f92f0f4fca72024f.webp";